import React from "react";
import LegalDoc from "@/components/LegalDoc";

export default function CookiePolicy() {
  return (
    <LegalDoc
      title="Cookie Policy"
      effectiveDate="10 February 2026"
      path="/cookie-policy"
      seoDescription="Sarthi Associates Cookie Policy — what cookies we use, how you can opt out, and how our advertising partners (Google AdSense) use cookies."
    >
      <p>This Cookie Policy explains how Sarthi Associates ("<strong>Sarthi</strong>", "<strong>we</strong>", "<strong>us</strong>") uses cookies and similar technologies when you visit <a href="https://www.sarthiassociates.com">https://www.sarthiassociates.com</a>. This Policy should be read together with our <a href="/privacy">Privacy Policy</a> and <a href="/terms">Terms of Service</a>.</p>

      <h2>1. What are cookies</h2>
      <p>1.1 Cookies are small text files that a website places on your device to remember information such as login state, language preference or advertising choices. Similar technologies include localStorage, sessionStorage, pixels and SDKs.</p>

      <h2>2. Categories of cookies we use</h2>
      <h3>2.1 Strictly necessary cookies (always on)</h3>
      <ul>
        <li>2.1.1 <code>access_token</code> — httpOnly, secure, samesite=lax · authenticates you across pages (7-day expiry)</li>
        <li>2.1.2 <code>sarthi_cookie_consent</code> — remembers your cookie preference (localStorage)</li>
        <li>2.1.3 CSRF and rate-limit tokens used to keep the Platform secure</li>
      </ul>
      <h3>2.2 Analytics cookies (with your consent)</h3>
      <ul>
        <li>2.2.1 Google Analytics 4 (<code>_ga</code>, <code>_ga_*</code>) — anonymised traffic and behaviour analytics</li>
      </ul>
      <h3>2.3 Advertising cookies (with your consent)</h3>
      <ul>
        <li>2.3.1 Google AdSense (<code>__gads</code>, <code>__gpi</code>, <code>IDE</code>, <code>NID</code>) — personalises the ads shown on the Platform and prevents duplicate ads</li>
        <li>2.3.2 Third-party ad-network cookies may be dropped by Google's partner networks</li>
      </ul>

      <h2>3. Managing your consent</h2>
      <p>3.1 When you first visit the Platform you will see a consent banner asking whether to allow analytics + advertising cookies in addition to strictly necessary cookies.</p>
      <p>3.2 You can change your preference any time by clearing your browser's site data and reloading — the banner will re-appear.</p>
      <p>3.3 You can opt out of personalised ads at any time via <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">Google Ad Settings</a>, or install browser extensions such as Google's Analytics Opt-out add-on.</p>

      <h2>4. Do we sell your data</h2>
      <p>4.1 <strong>No.</strong> We do not sell your personal data. Advertising cookies allow Google (and its partners) to serve you relevant ads but the underlying data is not shared with us in an identifiable form. See clauses 6 and 8 of our <a href="/privacy">Privacy Policy</a>.</p>

      <h2>5. Retention</h2>
      <p>5.1 Session cookies expire when you close your browser. Persistent cookies (analytics, ads) expire between 24 hours and 2 years depending on the provider.</p>

      <h2>6. Changes</h2>
      <p>6.1 We may update this Policy from time to time. The "Last updated" date reflects the current version.</p>

      <h2>7. Contact</h2>
      <p>7.1 Questions may be sent to <a href="mailto:contact@sarthiassociates.com">contact@sarthiassociates.com</a>.</p>
    </LegalDoc>
  );
}
